<script >
import { computed, inject, nextTick, onMounted, ref } from 'vue-demi';
import { BaseConfigKey } from '@futuweb/community-activity-modules/lib/vue2/provider-config/index.es.js';
import { SKIN_NUM, SKIN } from '../../constants/index';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const baseConfig = inject(BaseConfigKey);
  const skinStr = computed(() => {
    const skinNum = baseConfig.value.skin;
    if (skinNum === SKIN_NUM[SKIN.BLACK]) {
      return SKIN.BLACK;
    }
    return SKIN.WHITE;
  });
  const matchPreviousElement = ref(false);
  const matchNextElement = ref(false);
  const ele = ref(null);
  const show = computed(() => {
    return matchPreviousElement.value && matchNextElement.value;
  });
  onMounted(() => {
    nextTick().then(() => {
      if (ele.value) {
        const previousElement = ele.value.previousElementSibling;
        if (previousElement) {
          matchPreviousElement.value = previousElement.className.includes('module-wrapper');
        }
        let nextElement = ele.value.nextElementSibling;
        while (matchPreviousElement.value && nextElement && !nextElement.className.includes('module-wrapper')) {
          nextElement = nextElement.nextElementSibling;
        }
        if (nextElement) {
          matchNextElement.value = nextElement.className.includes('module-wrapper');
        }
      }
    });
  });
  return {
    skinStr,
    ele,
    show
  };
};
export default __sfc_main;
</script>
<template>
    <div
        v-show="show"
        ref="ele" :class="['multi-media-financial-report-gap', skinStr]"
    >
        <div class="gap-up"></div>
        <div class="gap-down"></div>
    </div>
</template>
<style lang="less" scoped>
.multi-media-financial-report-gap {
    &.white {
        .gap-up {
            height: 6PX;
            background-color: #F5F6F6;
        }
        .gap-down {
            height: 10PX;
            background-color: #FFFFFF;
        }
    }
    &.black {
        .gap-up {
            height: 6PX;
            background-color: #181A1C;
        }
        .gap-down {
            height: 10PX;
            background-color: #0F1112;
        }
    }
}
</style>
